import ReactModal from 'react-modal';
import React from 'react';

import styled from 'styled-components';
import { normal } from '../../styles/fonts';
import Modal from '../../templates/Modal';
import { StatefulRoom } from '../../lib/sendbird-calls/SbCallsContext';
import { InfoLabel, InputWithCopyIcon } from '../../molecules/Info';

const RoomCreated = (
  props: ReactModal.Props & {
    room: StatefulRoom;
    userId: string;
    assignmentId: string;
    close?: () => void;
  }
) => {
  return (
    <Modal
      isOpen={props.isOpen}
      close={() => props.close?.()}
      title="Call started, share the url with the guest."
      content={
        <>
          <InputWithCopyIcon
            text={`${
              process.env.NODE_ENV === 'development'
                ? 'http://localhost:3000'
                : `https://${window.location.hostname}`
            }/user/classes/calls/join/${props.userId}/${props.assignmentId}`}
          />
        </>
      }
      footer={{}}
    />
  );
};

const CreatedByText = styled.div`
  ${normal};
  letter-spacing: -0.1px;
  color: var(--navy-900);
  margin-top: 10px;
`;

export const RoomInfo = (props: ReactModal.Props & { close: () => void; room: StatefulRoom }) => {
  return (
    <Modal
      title="Room information"
      content={
        <>
          <InputWithCopyIcon title="Room ID" text={props.room.roomId} />
          <div style={{ marginTop: 24 }}>
            <InfoLabel>Created by</InfoLabel>
            <CreatedByText>User ID : {props.room.createdBy}</CreatedByText>
          </div>
        </>
      }
      footer={{
        confirm: {
          label: 'OK',
          onClick: () => {
            props.close();
          },
        },
      }}
      {...props}
    />
  );
};

export default RoomCreated;
